import * as React from 'react';

import { InlineNotification, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-ui';

export const DataDelayNotification = ({ callToAction }: { callToAction?: string }) => (
  <InlineNotification severity="information">
    <React.Fragment>
      <Typography2 component="p">{_t('The data can take a few seconds to update.')}</Typography2>
      {callToAction && <Typography2 component="p">{callToAction}</Typography2>}
    </React.Fragment>
  </InlineNotification>
);
